<script>
import {apiCreateGroups, apiDeleteGroups, apiUpdateGroups} from "@/api/user";
import {mapActions} from "vuex";

export default {
  name: "AccountSelector",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'single'
    },
    curAccountIds: {
      type: Array,
      default: () => []
    },
    accounts: {
      type: Array,
      default: () => []
    },
    groups: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localVisible: this.visible,
      accountSearchWord: '',
      selectedAccountIds: [],
      selectedGroup: 0,
      createGroupDialogFormVisible: false,
      editGroupDialogFormVisible: false,
      editingGroup: false,
      formLabelWidth: '80px',
      groupForm: {
        name: '',
        accountIds: [],
      }
    }
  },
  computed: {
    viewAccounts() {
      let accounts = [...this.accounts];

      if (this.type === 'multiple' && this.selectedGroup !== 0 && !this.editingGroup) {
        let group = this.groups.find(item => item.id === this.selectedGroup);
        accounts = accounts.filter(item => group.accountIds.indexOf(item.id) !== -1);
      }

      if (this.accountSearchWord !== '') {
        accounts = accounts.filter(item => item.nickname.includes(this.accountSearchWord) || item.account_code.includes(this.accountSearchWord));
      }

      return accounts;
    },
    showCreateGroupBtn() {

      if (this.type !== 'multiple') {
        return false;
      }

      if (this.selectedGroup !== 0) {
        return false;
      }

      return this.selectedAccountIds.length >= 2;
    },
    showDeleteGroupBtn() {
      if (this.type !== 'multiple') {
        return false;
      }

      return this.selectedGroup !== 0 && !this.editingGroup;
    },
    showSaveGroupBtn() {
      if (this.type !== 'multiple') {
        return false;
      }

      return this.selectedGroup !== 0 && this.editingGroup;
    },
    showEditGroupBtn() {
      if (this.type !== 'multiple') {
        return false;
      }

      return this.selectedGroup !== 0 && !this.editingGroup;
    }
  },
  methods: {
    ...mapActions(['fetchAllGroups']),
    open() {
      // this.editingGroup = false;
    },
    close() {
      // this.selectedAccountIds = [];
      // this.selectedGroup = 0;
      // this.editingGroup = false;
    },
    clickAccount(accountId) {
      if (this.type === 'multiple') {
        let index = this.selectedAccountIds.indexOf(accountId);
        if (index !== -1) {
          this.selectedAccountIds.splice(index, 1);
        } else {
          this.selectedAccountIds.push(accountId);
        }
      } else {
        this.selectedAccountIds = [accountId];
      }
    },
    selectAll() {
      if (this.viewAccounts.every(value => this.selectedAccountIds.includes(value.id))) {
        this.selectedAccountIds = [];
      } else {
        this.selectedAccountIds = this.viewAccounts.map(obj => obj.id);
      }
    },
    selectReverse() {
      this.selectedAccountIds = this.viewAccounts.map(obj => obj.id).filter(id => !this.selectedAccountIds.includes(id))
    },
    async createGroup() {
      this.groupForm.accountIds = [...this.selectedAccountIds];
      if (this.groupForm.name === "") {
        this.$message({
          type: 'warning',
          message: '请输入分组名称'
        });
        return false;
      }

      if (this.groupForm.accountIds.length < 2) {
        this.$message({
          type: 'warning',
          message: '请输至少选择两个账户'
        });
        return false;
      }

      let res = await apiCreateGroups(this.groupForm);
      if (res.data.code === 0) {
        this.$message({
          type: 'success',
          message: '创建分组成功!'
        });
        await this.fetchAllGroups();
        this.createGroupDialogFormVisible = false;
        this.groupForm.name = "";
        this.groupForm.accountIds = [];
      } else {
        this.$message({
          type: 'error',
          message: res.data.data
        });
      }
    },
    editGroup() {
      let group = this.groups.find(item => item.id === this.selectedGroup);
      this.groupForm.name = group.name;
      this.editingGroup = true;
    },
    async saveGroup() {
      this.groupForm.accountIds = [...this.selectedAccountIds];
      if (this.groupForm.name === "") {
        this.$message({
          type: 'warning',
          message: '请输入分组名称'
        });
        return false;
      }

      if (this.groupForm.accountIds.length < 2) {
        this.$message({
          type: 'warning',
          message: '请输至少选择两个账户'
        });
        return false;
      }

      let res = await apiUpdateGroups(this.selectedGroup, this.groupForm);
      if (res.data.code === 0) {
        this.$message({
          type: 'success',
          message: '保存分组成功!'
        });
        await this.fetchAllGroups();
        this.editingGroup = false;
        this.groupForm.name = "";
        this.groupForm.accountIds = [];
      } else {
        this.$message({
          type: 'error',
          message: res.data.data
        });
      }
    },
    deleteGroup() {
      this.$confirm('确定要删除该分组吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiDeleteGroups(this.selectedGroup).then(response => {
          if (response.data.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.selectedGroup = 0;
            this.fetchAllGroups();
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!'
            });
          }
        })
      });
    },
    clickGroup(group) {
      if (this.selectedGroup === group.id) {
        this.selectedGroup = 0;
        this.selectedAccountIds = [];
      } else {
        this.selectedGroup = group.id;
        this.selectedAccountIds = [...group.accountIds];
      }
      this.editingGroup = false;
      return false;
    },
    handleOk() {
      this.$emit('change', this.selectedAccountIds);
      this.selectedGroup = 0;
      this.selectedAccountIds = [];
    }
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
    },
    localVisible(newVal) {
      this.$emit('update:visible', newVal);
      if (!newVal) {
        this.selectedAccountIds = [];
        this.selectedGroup = 0;
        this.editingGroup = false;
      }
    },
    curAccountIds() {
      this.selectedAccountIds = [...this.curAccountIds];
    }
  },
  mounted() {
    this.selectedAccountIds = [...this.curAccountIds];
  }
}
</script>

<template>
  <div class="account-selector">
    <el-dialog :visible.sync="localVisible" width="900px" top="5vh" class="account-dialog" :open="open" :closed="close">
      <template #title>
        <el-row>
          <el-col :span="8">
            <div class="account-selector-title">
              {{ type === 'single' ? '选择单账户' : (type === 'multiple' ? '选择多账户' : '选择账户组') }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="account-selector-search-box">
              <el-input v-model="accountSearchWord" placeholder="输入关键字搜索账户" size="mini"></el-input>
            </div>
          </el-col>
        </el-row>
        <div class="account-selector-group" v-if="type === 'multiple'">
          <span>分组：</span><span :class="['item', selectedGroup === item.id ? 'selected' : '']" v-for="item in groups"
                                  :key="item.id" @click="clickGroup(item)">{{ item.name }}</span>
        </div>
      </template>

      <el-row :gutter="5">
        <el-col :span="6" v-for="(item) in viewAccounts" :key="item.id" class="mt5">
          <el-card :class="selectedAccountIds.indexOf(item.id) !== -1 ? 'selected' : ''"
                   @click.native="clickAccount(item.id)">
            <p>{{ item.nickname }}</p>
            <p>({{ item.account_code }})</p>
          </el-card>
        </el-col>
      </el-row>

      <template #footer>
        <el-row>
          <el-col :span="12" class="type-btn-box" style="min-height: 1px">
            <el-button size="small" @click="createGroupDialogFormVisible = true" v-show="showCreateGroupBtn">创建分组
            </el-button>
            <el-button size="small" @click="editGroup" v-show="showEditGroupBtn">编辑分组</el-button>
            <el-button size="small" type="danger" @click="deleteGroup" v-show="showDeleteGroupBtn">删除分组</el-button>
            <el-row v-show="showSaveGroupBtn">
              <el-col :span="10">
                <el-input v-model="groupForm.name" placeholder="输入分组名称" size="mini"></el-input>
              </el-col>
              <el-col :span="12" :offset="2">
                <el-button size="small" type="primary" @click="saveGroup">保存分组</el-button>
                <el-button size="small" @click="editingGroup = false">取消编辑</el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" class="control-btn-box">
            <el-button class="all-select-btn" size="small" @click="selectAll"
                       v-show="type === 'multiple' && !editingGroup">全 选
            </el-button>
            <el-button class="all-select-btn" size="small" @click="selectReverse"
                       v-show="type === 'multiple' && !editingGroup">反 选
            </el-button>
            <el-button type="warning" class="ok-btn"
                       v-show="type !== 'multiple' || (type === 'multiple' && !editingGroup)" @click="handleOk">确 定
            </el-button>
          </el-col>
        </el-row>
      </template>
    </el-dialog>

    <el-dialog title="创建分组" :visible.sync="createGroupDialogFormVisible" width="400px"
               :close-on-click-modal="false">
      <el-form :model="groupForm">
        <el-form-item label="分组名称" :label-width="formLabelWidth">
          <el-input v-model="groupForm.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createGroupDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createGroup">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.account-selector {

  .account-dialog {

    ::v-deep(.el-dialog) {

      .el-dialog__header {
        position: relative;
        z-index: 1;
        box-shadow: 0 2px 2px rgba(150, 150, 150, 0.3);

        .account-selector-title {
          text-align: left;
          font-size: 16px;
          font-weight: bold;
        }

        .account-selector-group {
          text-align: left;
          padding: 2px;

          span.item {
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            box-sizing: border-box;
            cursor: pointer;
            background: rgba(150, 150, 150, 0.3);
            border: 0;
            border-radius: 2px;
            padding: 3px 4px;
            font-size: 14px;
            line-height: 14px;
            margin-right: 5px;
            color: #333333;

            &.selected {
              background: #DD593B;
              color: #FFFFFF;
            }
          }
        }
      }

      .el-dialog__body {
        width: 100%;
        height: calc(90vh - 200px);
        padding: 2px 20px 20px 20px;
        overflow-x: hidden;
        box-sizing: border-box;
        overflow-y: auto;
        scrollbar-width: thin;

        .el-row {
          .el-card {
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;

            &:hover {
              cursor: pointer;
              box-shadow: 0 2px 12px 0 rgba(255, 223, 215);
              border-color: rgba(255, 223, 215);
            }

            p {
              line-height: 24px;
              font-size: 14px;
              margin: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            &.selected {
              transition: none;
              background-image: url("../assets/selected_bg.png");
              background-position: right bottom;
              background-size: 50px 50px;
              background-repeat: no-repeat;
            }
          }
        }
      }

      .el-dialog__footer {
        .type-btn-box {
          text-align: left;
          line-height: 40px;

          .edit-box {
            input {
              width: 120px;
            }
          }

          //
          //
          //.el-button {
          //  &:hover, &:focus {
          //    background: none;
          //    color: #DD593B;
          //    border-color: #DCDFE6;
          //  }
          //
          //  &.selected {
          //    transition: none;
          //    background-image: url("../assets/selected_bg.png");
          //    background-position: right bottom;
          //    background-size: 25px 25px;
          //    background-repeat: no-repeat;
          //    color: #DD593B;
          //  }
          //}
        }

        .control-btn-box {
          text-align: right;
          .ok-btn {
            background: #DD593B;
            color: #FFFFFF;
            border-color: #DD593B;
            width: 120px;

            &:hover {
              opacity: 0.9;
            }
          }
        }
      }
    }
  }
}
</style>
